/**
 * Génère un ObjectId MongoDB-compatible (24 caractères hexadécimaux) côté navigateur,
 * sans dépendance à la lib `bson` (qui tire `crypto` Node).
 *
 * Format spec MongoDB ObjectId (12 bytes) :
 *   - 4 bytes : timestamp Unix en secondes
 *   - 5 bytes : valeur aléatoire (process unique)
 *   - 3 bytes : compteur incrémental
 *
 * Compatible avec ObjectId.isValid() côté backend.
 */

// Process unique = 5 bytes random générés une seule fois par session
const PROCESS_UNIQUE = (() => {
  const bytes = new Uint8Array(5);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 5; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
})();

let counter = (() => {
  const bytes = new Uint8Array(3);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 3; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return ((bytes[0] << 16) | (bytes[1] << 8) | bytes[2]) & 0xffffff;
})();

function toHex(byte: number): string {
  return byte.toString(16).padStart(2, '0');
}

/**
 * Génère un nouvel ObjectId hex (24 caractères).
 */
export function generateObjectIdHex(): string {
  const timestamp = Math.floor(Date.now() / 1000);
  counter = (counter + 1) & 0xffffff;

  const bytes = new Uint8Array(12);
  bytes[0] = (timestamp >> 24) & 0xff;
  bytes[1] = (timestamp >> 16) & 0xff;
  bytes[2] = (timestamp >> 8) & 0xff;
  bytes[3] = timestamp & 0xff;
  bytes[4] = PROCESS_UNIQUE[0];
  bytes[5] = PROCESS_UNIQUE[1];
  bytes[6] = PROCESS_UNIQUE[2];
  bytes[7] = PROCESS_UNIQUE[3];
  bytes[8] = PROCESS_UNIQUE[4];
  bytes[9] = (counter >> 16) & 0xff;
  bytes[10] = (counter >> 8) & 0xff;
  bytes[11] = counter & 0xff;

  let hex = '';
  for (let i = 0; i < 12; i++) hex += toHex(bytes[i]);
  return hex;
}
